/**
 * Where a turn starts. One rule for the Changes cards, the header total and
 * the thread's row grouping, so the three cannot disagree about a boundary.
 */
import type { TranscriptMessage } from '@mod/core/model'

/**
 * A person's prompt, or any message with a run, starts a turn, unless its run
 * has not taken a step. The projection leaves such a prompt where it was
 * posted, inside the turn that was running, so it does not end that turn.
 */
export function startsTurn(message: TranscriptMessage | undefined): boolean {
  if (!message) return false
  if (message.role !== 'user' && !message.runStatus) return false
  if (message.runStatus === 'queued') return false
  return message.runStarted !== false
}
